<template>
  <v-container fluid class="ma-0 pa-0">
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <v-col cols="12" class="ma-0 pa-0">
      <v-row align="start" justify="start" justify-md="center" class="ma-0 pa-0" v-if="schoolData.id">
        <v-col cols="12" md="8" class="ma-0 pa-0">
          <college-course-card
            :loading="loading"
            :school="schoolData"
            :country-name="_country.name"
            :country-id="_country.id"
            :country-flag="`${flagsPath}${_country.iso_code}.png`"
          />
        </v-col>
        <v-col cols="12" md="4" class="ma-0 pa-0">
          <college-course-actions
            @onCreate="openCreateNewCourseModal()"
            @onUpload="openMassiveLoadModal()"
            :schoolId="schoolData.id"
            :countryId="_country.id.toString()"
            :dataForExport="directivesListAsExport"
            :csvTitle="csvTitle"
            :csvHeaders="csvHeaders"
            :hideCreateUser="true"
          />
          <v-row align="center" justify="center" class="mt-2 mb-2">
            <v-btn text small color="deep-purple lighten-1" outlined rounded @click="openCreateDirectiveModal()">
              <v-icon size="21" class="mr-1">mdi-plus</v-icon>
              {{ $t('directive_admins.create') }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="px-3">
      <v-row v-if="schoolData.id">
        <college-course-directives-table
          :list="directivesLists"
          v-model="page"
          :page-count="totalPage"
          :country-id="_country.id"
          :school-id="schoolData.id"
        />
          <!-- @reSearch="reSearch" -->
      </v-row>
    </v-col>

    <!------- ACTIONS MODALS ------->
    <massive-load-modal
      :school="schoolData"
      v-model="isMassiveLoadModalOpen"
      @onCancel="closeMassiveLoadModal"
    />

    <!-- Create new course modal -->
    <general-modal v-if="isCreateNewCourseModalOpen">
      <college-create-new-course-modal
        :country-id="country"
        :school="schoolData.id"
        @onSave="onCreateNewCourse"
        @onCancel="closeCreateNewCourseModal()"
      />
    </general-modal>

    <!-- Disable course modal -->
    <general-modal v-if="isDisableCourseModalOpen">
      <college-disable-course-modal
        @onDisable="onDisableCourse()"
        @onCancel="closeDisableCourseModal()"
      />
    </general-modal>

    <!-- Create directive modal -->
    <create-directive-admin-modal
      v-model="isCreateDirectiveModalOpen"
      :school-id="schoolData.id"
      @onCancel="closeCreateDirectiveModal()"
      @onSave="handleDirectiveCreated()"
    />
  </v-container>
</template>

<script>
import MassiveLoadModal from '@/components/colleges/modals/MassiveLoadModal.vue';
import CollegeCourseCard from '../../../components/colleges/courses/CollegeCourseCard.vue';
import CollegeCourseActions
  from '../../../components/colleges/courses/CollegeCourseActions.vue';
import CollegeCourseDirectivesTable
  from '../../../components/colleges/courses/CollegeCourseDirectivesTable.vue';
import GeneralModal from '../../../components/core/modals/GeneralModalContainer.vue';
import CollegeDisableCourseModal
  from '../../../components/colleges/modals/DisableCourseModal.vue';
import CollegeCreateNewCourseModal
  from '../../../components/colleges/modals/CreateNewCourseModal.vue';
import CreateDirectiveAdminModal
  from '../../../components/directiveAdmins/modals/CreateDirectiveAdminModal.vue';

import LoadingMixin from '../../../mixins/loading';
import SnackbarMixin from '../../../mixins/snackbar';
import schoolService from '../../../services/school.service';
import userService from '../../../services/user.service';
import { FLAGS_URL, RECORDS_PER_PAGE } from '../../../constants/data';
import { defaultCourseSchoolFilter } from '../../../constants/filters';

export default {
  name: 'CollegeDirectivesDetail',
  components: {
    CollegeCourseCard,
    CollegeCourseActions,
    CollegeCourseDirectivesTable,
    MassiveLoadModal,
    GeneralModal,
    CollegeDisableCourseModal,
    CollegeCreateNewCourseModal,
    CreateDirectiveAdminModal,
  },
  async mounted() {
    this.loader();
    const { collegeId } = this.$route.params;
    const { status, data } = await schoolService.findOne(collegeId);
    if (status === 200) {
      this.schoolData = { ...data };
      this.country = this.schoolData.baseCountry_id;
      await this.loadDirectives();
    }
    this.loader();
  },
  data: () => ({
    isCreateNewCourseModalOpen: false,
    isMassiveLoadModalOpen: false,
    isDisableCourseModalOpen: false,
    isCreateDirectiveModalOpen: false,
    country: 0,
    schoolData: {},
    flagsPath: `${FLAGS_URL}countries_flags/`,
    params: { ...defaultCourseSchoolFilter },
    directivesLists: [],
    directivesListAsExport: [],
    csvTitle: '',
    csvHeaders: {
      id: { title: 'ID' },
      dni: { title: 'DNI' },
      firstname: { title: 'Nombre' },
      lastname: { title: 'Apellidos' },
      active: { title: 'Estado' },
      password: { title: 'Contraseña ' },
      email: { title: 'Correo' },
      username: { title: 'Nombre de usuario' },
      creationDate: { title: 'Fecha de creación' },
      birthDay: { title: 'Fecha de nacimiento' },
      lastAccessDate: { title: 'Fecha último ingreso' },
    },
    page: 1,
    totalPage: 0,
  }),
  computed: {
    _country() {
      return this.schoolData.country || {};
    },
  },
  methods: {
    async loadDirectives() {
      const { collegeId } = this.$route.params;
      const { status, data } = await userService.findAllDirectivesBySchool(this.page, collegeId, true);
      if (status !== 200) return;
      this.directivesLists = [...data];
      this.totalPage = parseInt(data.length / RECORDS_PER_PAGE, 10);
      this.csvTitle = `${this.schoolData.id} ${this.schoolData.name} - Listado de directivos`;
      this.directivesListAsExport = data.map((st) => {
        const directiveToExport = Object.fromEntries(
          Object.keys(this.csvHeaders).map((header) => [header, st[header]]),
        );
        return {
          ...directiveToExport,
          password: st.passwordTmp,
          active: st.active ? 'Activo' : 'Inactivo',
          lastname: `${st.lastname} ${st.lastname2nd}`,
        };
      });
    },
    // Create new course
    onCreateNewCourse(success) {
      if (success) {
        this.snackbarSuccess(this.$t('colleges.course_saved_success'));
        this.closeCreateNewCourseModal();
      } else this.snackbarError(this.$t('common.an_error_ocurred'));
    },
    openCreateNewCourseModal() {
      this.isCreateNewCourseModalOpen = true;
    },
    openMassiveLoadModal() {
      this.isMassiveLoadModalOpen = true;
    },
    closeCreateNewCourseModal() {
      this.isCreateNewCourseModalOpen = false;
    },
    closeMassiveLoadModal() {
      this.isMassiveLoadModalOpen = false;
    },
    // Disable course
    onDisableCourse() {
      console.log('TODO');
    },
    openDisableCourseModal() {
      this.isDisableCourseModalOpen = true;
    },
    closeDisableCourseModal() {
      this.isDisableCourseModalOpen = false;
    },
    // Create directive
    openCreateDirectiveModal() {
      this.isCreateDirectiveModalOpen = true;
    },
    closeCreateDirectiveModal() {
      this.isCreateDirectiveModalOpen = false;
    },
    async handleDirectiveCreated() {
      this.closeCreateDirectiveModal();
      this.snackbarSuccess('Directivo creado exitosamente');
      await this.loadDirectives();
    },
  },
  mixins: [LoadingMixin, SnackbarMixin],
};
</script>
